
import { getMaxBounds } from "../../../../utils/commonFunctions";

export const computeDropdownPosition = (
    triggerRect: DOMRect,
    contentRect: DOMRect,
    placement: 'top' | 'bottom' | 'auto',
    margin = 8
) => {
    const { width, height } = getMaxBounds();
    const viewport = {
        width,
        height
    };

    const scrollX = window.scrollX || window.pageXOffset;
    const scrollY = window.scrollY || window.pageYOffset;

    const spaceAbove = triggerRect.top;
    const spaceBelow = viewport.height - triggerRect.bottom;

    const fitsBelow = contentRect.height + margin <= spaceBelow;
    const fitsAbove = contentRect.height + margin <= spaceAbove;

    let finalPlacement: 'top' | 'bottom' = 'bottom';

    if (placement === 'top' && fitsAbove) finalPlacement = 'top';
    else if (placement === 'bottom' && !fitsBelow && fitsAbove) finalPlacement = 'top';
    else if (placement === 'auto') {
        finalPlacement = fitsBelow ? 'bottom' : fitsAbove ? 'top' : 'bottom';
    }

    // FIXED POSITION COORDINATES
    const top =
        finalPlacement === 'bottom'
            ? triggerRect.bottom + margin + scrollY
            : triggerRect.top - contentRect.height - margin + scrollY;

    let left = triggerRect.left + scrollX;

    const contentWidth = contentRect.width || triggerRect.width;

    // Prevent overflow RIGHT
    if (left + contentWidth + margin > viewport.width + scrollX) {
        left = viewport.width + scrollX - contentWidth - margin;
    }

    // Prevent overflow LEFT
    if (left < scrollX + margin) left = scrollX + margin;

    return {
        top: Math.round(top),
        left: Math.round(left),
        placement: finalPlacement
    };
};
